import React from "react";
import { AvatarProps } from "../../types/avatar-types";
import { useAvatar } from "../../hooks/useAvatar";

const Avatar: React.FC<AvatarProps> = ({
  src,
  alt = "Avatar",
  name,
  size = "medium",
  shape = "circle",
  style = {},
  className = "",
}) => {
  const { avatarStyle, handleError, shouldShowImage, initials } = useAvatar({
    src,
    name,
    alt,
    size,
    shape,
    style,
  });

  if (shouldShowImage) {
    return (
      <div style={avatarStyle} className={className}>
        <img
          src={src}
          alt={alt}
          onError={handleError}
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      </div>
    );
  }

  return (
    <div style={avatarStyle} className={className}>
      {initials}
    </div>
  );
};

export default Avatar;
